import CardSidePanel from "componentsv2/panel/CardSidePanel";
import { cn } from "tools/ui";

const base =
  "h-26 bg-neutral-50 border border-neutral-300 shadow-md px-1 py-1 rounded-lg overflow-hidden grid justify-between gap-1";

function SectionSidePanel({ data }) {
  const cols = `grid-cols-${data?.length || 1}`;
  return (
    <div key="section-side-panel" className={cn(base, cols)}>
      {data?.map((card) => (
        <CardSidePanel key={card.name} {...card} />
      ))}
    </div>
  );
}

export default SectionSidePanel;
